// src/pages/About/index.jsx
import React, { useState } from 'react';
import { Button, Form, Input, Modal, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './index.css';

const About = () => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  // 添加状态来管理用户信息
  const [userInfo, setUserInfo] = useState({
    avatar: '/头像.jpg',
    name: 'Cici',
    intro: '今日份电量满格！把烦恼调成静音模式，带着快乐一路开挂，冲就完事啦~',
    welcome: '欢迎来到我的博客！请登陆后完善您的个人信息！',
    email: 'Cici@blog.com',
    techStack: 'React / Node.js / Ant Design',
    hobbies: '摄影、美食、撸猫、旅行'
  });

  // 打开 Modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // 关闭 Modal
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // 提交表单并关闭 Modal
  const handleOk = () => {
    form.validateFields().then((values) => {
      console.log('提交的数据:', values);
      // 更新用户信息状态
      setUserInfo(prevInfo => ({
        ...prevInfo,
        ...values
      }));
      setIsModalOpen(false);
      message.success('个人信息更新成功！');
    }).catch(error => {
      console.error('表单验证失败:', error);
    });
  };

  // 上传头像处理函数
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('只能上传 JPG/PNG 格式的图片!');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片大小不能超过 2MB!');
      return false;
    }
    return isJpgOrPng && isLt2M;
  };

  // 处理头像上传
  const handleAvatarChange = (info) => {
    if (info.file.status === 'done') {
      // 这里可以获取上传后的图片URL
      const imageUrl = URL.createObjectURL(info.file.originFileObj);
      // 更新用户信息中的头像
      setUserInfo(prevInfo => ({
        ...prevInfo,
        avatar: imageUrl
      }));
      message.success(`${info.file.name} 上传成功`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} 上传失败`);
    }
  };

  return (
    <div className="about-page">
      {/* 头部区域 */}
      <div className="header-section">
        <div className="avatar-container">
          <img 
            src={userInfo.avatar} 
            alt="头像" 
            className="avatar" 
          />
        </div>
        <h1>Hi，我是 {userInfo.name}!</h1>
        <p className="intro">{userInfo.intro}</p>
        <p className="welcome">{userInfo.welcome}</p>
      </div>
      
      {/* 个人信息卡片 */}
      <div className="info-card">
        <div className="info-row">
          <span className="label">邮箱</span>
          <span className="value">{userInfo.email}</span>
        </div>
        <div className="info-row">
          <span className="label">技术栈</span>
          <span className="value">{userInfo.techStack}</span>
        </div>
        <div className="info-row">
          <span className="label">兴趣爱好</span>
          <span className="value">{userInfo.hobbies}</span>
        </div>
      </div>

      {/* 编辑按钮 */}
      <Button type="primary" onClick={showModal} className="edit-btn">
        编辑个人信息
      </Button>

      {/* Modal 弹窗 */}
      <Modal
        title="编辑个人信息"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="保存"
        cancelText="取消"
        width={600}
      >
        <Form
          layout="vertical"
          form={form}
          initialValues={userInfo}
          style={{ maxWidth: 600 }}
        >
          <Form.Item label="头像" name="avatar">
            <Upload
              name="avatar"
              listType="picture-card"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleAvatarChange}
            >
              <div>
                <UploadOutlined />
                <div style={{ marginTop: 8 }}>上传头像</div>
              </div>
            </Upload>
          </Form.Item>
          
          <Form.Item 
            label="姓名" 
            name="name"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input placeholder="请输入姓名" />
          </Form.Item>
          
          <Form.Item 
            label="个人介绍" 
            name="intro"
            rules={[{ required: true, message: '请输入个人介绍' }]}
          >
            <Input placeholder="请输入个人介绍" />
          </Form.Item>
          
          <Form.Item 
            label="更详细的介绍" 
            name="welcome"
            rules={[{ required: true, message: '请输入更详细的介绍' }]}
          >
            <Input.TextArea 
              placeholder="请输入更详细的介绍" 
              rows={4}
              showCount
              maxLength={200}
            />
          </Form.Item>
          
          <Form.Item 
            label="邮箱" 
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '请输入有效的邮箱地址' }
            ]}
          >
            <Input placeholder="请输入邮箱" />
          </Form.Item>
          
          <Form.Item label="技术栈" name="techStack">
            <Input placeholder="请输入技术栈" />
          </Form.Item>
          
          <Form.Item label="兴趣爱好" name="hobbies">
            <Input placeholder="请输入兴趣爱好" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default About;